<script>
import AutocompleteSearch from '@components/navigation/search/autocomplete-search.vue'
import SearchMixin from '@src/mixins/searchMixin'
import Translatable from '@src/mixins/translatable.js'

import { mapGetters } from 'vuex'

export default {
  components: {
    AutocompleteSearch
  },
  mixins: [
    SearchMixin,
    Translatable
  ],
  props: {
    attractions: {
      type: Array,
      // required: true
    },
    isError: {
      type: Boolean,
      // required: true
    },
    typeOf: {
      type: String,
      default: 'home'
    }
  },
  computed: {
    ...mapGetters('home', [
      'isEmptySearch',
    ]),
    ...mapGetters('translations', [
      'currentLanguage',
    ]),
  },

  methods: {
    setXHRValue(obj) {
      this.$store.commit('home/SET_REDIRECT_VALUE', obj.value)
    },

    distributionGroupsEndpoint(input) {
      if (this.isEmptySearch) {
        this.$store.commit('home/SET_BUTTON_EVENT', !this.isEmptySearch)
      }

      return `${process.env.VUE_APP_API_BASE_URL}search?lang=${this.currentLanguage}&q=${input}`
    },
  },
}
</script>

<template>
  <div class="search-container">
    <label>
      <AutocompleteSearch
        v-if="typeOf === 'home'"
        ref="search"
        input-class="attractions-search"
        :current-language="currentLanguage"
        :source="distributionGroupsEndpoint"
        :placeholder="getTranslatedContent('SEARCH')"
        @selected="setXHRValue"
      >
        <li slot="isEmptySearch" class="autocomplete__results__item autocomplete__results__item__message">{{ getTranslatedContent('SEARCH_empty') }}</li>
        <li slot="noResults" class="autocomplete__results__item autocomplete__results__item__message">{{ getTranslatedContent('SEARCH_not_found') }}</li>
      </AutocompleteSearch>
      <AutocompleteSearch
        v-else
        ref="search"
        input-class="attractions-search"
        :current-language="currentLanguage"
        :source="distributionGroupsEndpoint"
        :placeholder="getTranslatedContent('SEARCH')"
        :is-clear="true"
        @selected="redirectToAttraction"
      >
        <li slot="isEmptySearch" class="autocomplete__results__item autocomplete__results__item__message">{{ getTranslatedContent('SEARCH_empty') }}</li>
        <li slot="noResults" class="autocomplete__results__item autocomplete__results__item__message">{{ getTranslatedContent('SEARCH_not_found') }}</li>
      </AutocompleteSearch>
    </label>
    <div class="magnifying-glass">
    </div>
  </div>

</template>

<style lang="scss" scoped>
@import '@design';

.search-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 270px;
  position: relative;
}

::v-deep .autocomplete__inputs {
  width: 100%;
}

::v-deep .autocomplete__box {
  width: 270px;
}

::v-deep .attractions-search {
  background: #FFFFFF;
  border-radius: 5px;
  border: none;
  width: 239px;
  height: 37px;
  padding: 0;
  text-indent: 12px;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 165%;
  color: $dark-blue;
  text-transform: capitalize;

  ::placeholder {
    font-family: Open Sans, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 165%;
    color: $dark-blue;
    opacity: 0.4;
  }
}

::v-deep .autocomplete__results {
  max-height: 220px;
}

::v-deep .autocomplete__results__item__message {
  text-transform: none !important;
}

.magnifying-glass {
  width: 20px;
  height: 20px;
  background: url("../../../assets/icons/search.svg") center;
  cursor: pointer;
  right: 9px;
  position: absolute;
}


@media only screen and (max-width: $screen-width-xs + 1) {
  ::v-deep .attractions-search {
    width: 100%;
    border: 1px solid #DBDBDB;
  }

  ::v-deep .autocomplete__inputs {
    width: 100%;
  }

  ::v-deep .autocomplete__searching {
    .attractions-search {
      border: none;
    }
  }

  ::v-deep .autocomplete__box {
    width: 100%;
    padding: 0 !important;
  }

  label {
    width: 100%;
  }

  .search-container {
    justify-content: flex-start;
    width: 100%;
  }
}
</style>
